import { TimelineMax, TweenMax, Expo } from 'gsap';
import hades from '@/scripts/hades';
import utils from '@/scripts/utils';

export function parentChildIn(el, delay) {
  const tl = new TimelineMax({
    delay,
  });

  const title = el.querySelector(`[data-nav]`);
  title.children[0].dataset.animated = 'true';

  tl
    .addLabel('start')
    .set(el, {
      autoAlpha: 1,
    }, 'start');

  return tl;
}

export function parentChildOut(el, item, route) {
  const tl = new TimelineMax();
  const scrollY = hades.ref.amount.y;

  const title = document.querySelector(`main[js-page="${route}"] [data-nav="${route}"]`);
  const bounding = title.getBoundingClientRect();

  const texts = Array.from(el.querySelectorAll('[data-anim="text"]'));

  tl
    .add('start')
    .set(item, {
      display: 'block',
    }, 'start')
    .set(el, {
      position: 'absolute',
      maxWidth: '100vw',
      width: '100%',
      zIndex: 5,
      top: 0,
      y: -scrollY,
      pointerEvents: 'none',
    }, 'start')
    .to(el.children, 0.4, {
      autoAlpha: 0,
      ease: Power2.easeOut,
    }, 'start')
    .to(texts, 0.6, {
      y: 50,
      ease: Power2.easeOut,
    }, 'start')
    .to(item, 1.5, {
      top: bounding.top + scrollY,
      y: 0,
      left: bounding.left,
      ease: Expo.easeInOut,
    }, 'start');

  return tl;
}